<!-- 图文-列表 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<p class="header-title">{{ info.title }}</p>
			</div>
		</div>

		<ul class="list">
			<li v-for="(item, index) in (info.item_list || [])" :key="index" @click="toDetail(info.id, item.id, item.is_vip)">
				<img :src="item.cover" class="img">
				<div class="item-sidebar">
					<p class="item-name">{{ item.title }}</p>
				</div>
			</li>
		</ul>

    <!-- 显示开通vip -->
    <van-overlay :show="showOpenVip" @click="showOpenVip = false" z-index="99999">
      <div class="open-vip">
        <p>仅支持VIP查看</p>
        <p>开通VIP查看本材料</p>
        <button @click="$router.push('/member')">开通VIP会员</button>
      </div>
    </van-overlay>
	</div>
</template>

<script>
import {ArticleService, UserCenterService} from "@/common/service";
import {Dialog} from "vant";

  export default {
		components: {},
		data() {
			return {
        showOpenVip: false,
        info: {
          id: 0
        },

        isLogin: false,
        isVip: false,
      };
		},
		mounted() {
      const option = this.$route.query;
      this.info.id = parseInt(option.id || 0);
      if (this.info.id > 0) {
        this.getArticleDetail();
      }
      this.getUserInfo();
    },
		methods: {
      getArticleDetail() {
        ArticleService.getArticleDetail({id: this.info.id}).then(({data}) => this.info = data.detail);
      },

      getUserInfo() {
        UserCenterService.getUserInfo().then(({ data }) => {
          this.isLogin = true;
          const userLevel = data.user_level;
          if (userLevel && userLevel.id > 0) {
            const currentTime = new Date().getTime();
            const endTime = new Date(userLevel.end_date.replace(/-/g, '/')).getTime();
            this.isVip = currentTime < endTime;
          }
        });
      },
      toDetail(id, item_id, is_vip) {
        if (is_vip === 1) {
          if (!this.isLogin) {
            return Dialog.confirm({
              message: 'VIP图文请登录后查看',
              confirmButtonText: '去登录'
            }).then(() => {
              this.$router.push('/login');
            });
          }
          if (!this.isVip) {
            return this.showOpenVip = true;
          }
        }
        this.$router.push(`/image-text-details?id=${id}&item_id=${item_id}`)
      }
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 44px 0 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 44px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 16px;
	}

	.img {
		width: 100px;
		height: 62px;
		margin-right: 21px;
		object-fit: cover;
		border-radius: 7px;
	}

	.item-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.item-name {
		width: 100%;
		color: #222222;
		font-size: 15px;
		font-weight: bold;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}
  .open-vip {
    width: 275px;
    height: 170px;
    background: #FFFFFF;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 273px auto 0;
  }

  .open-vip p {
    font-size: 16px;
    font-weight: 500;
    color: #222222;
    line-height: 35px;
  }

  .open-vip button {
    width: 215px;
    height: 40px;
    background: #EBD793;
    border-radius: 20px;
    font-size: 15px;
    font-weight: 500;
    color: #553D0E;
    margin-top: 10px;
  }
</style>
